module.exports = __webpack_public_path__ + "img/NW15.eae62cfe.gif";